<template>
  <div class="onway-panel">
    <div class="main-box" :style="{ height }">
      <div class="map" ref="mapEl"></div>
      <div class="right-box">
        <el-switch v-model="showDep" active-text="起点" inactive-text="终点"></el-switch>
      </div>

      <div class="table">
        <el-table :data="list" :row-class-name="tableRowClassName" :highlight-current-row="true" max-height="300"
          @row-click="shouMatchResult" size="small">
          <el-table-column label="序号" type="index" show-overflow-tooltip width="50"></el-table-column>
          <el-table-column prop="userTel" label="手机号" width="100"></el-table-column>
          <el-table-column label="时间" width="120">
            <template slot-scope="scope">
              <div>{{ scope.row.order && scope.row.order.dateTime | ticketTime }}</div>
            </template>
          </el-table-column>
          <el-table-column label="订单信息" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.order">
                {{ scope.row.order.date | dateFormat("MM-dd") }} &nbsp;&nbsp;
                {{ scope.row.order.number }}人
              </div>
              <div v-if="scope.row.order">{{ scope.row.order.pathId | enumTransfer(pathOpts) }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="下单时间" width="120">
            <template slot-scope="scope">
              <div>{{ scope.row.createTime | dateFormat("MM-dd hh:mm:ss") }}</div>
            </template>
          </el-table-column>
          <el-table-column label="推荐">
            <template slot-scope="scope">
              <div v-if="scope.row.okTickets">
                <div v-for="item in scope.row.okTickets" :key="item.id">{{ item.showTime }}</div>
              </div>
              <div>{{ scope.row.remark }}</div>
            </template>
          </el-table-column>
          <el-table-column label="重点">
            <template slot-scope="scope">
              <div v-if="!scope.row.isOk">
                <span v-if="scope.row.okTickets && !scope.row.okTickets.length">无推荐时间 </span>
                <span v-if="!scope.row.hasNoRecommendPoints">
                  <span v-if="!scope.row.recommendResult"> 没有查看推荐点</span>
                  <span v-else-if="!(scope.row.recommendResult.recommendAddressPoints || []).length">无推荐点</span>
                </span>
              </div>
              <div v-else>{{ scope.row.finalResult }}</div>
            </template>
          </el-table-column>
          <el-table-column label="总耗时" width="90">
            <template slot-scope="scope">
              <div>{{ formatCheckCost(scope.row.checkCostMs) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="标记" width="140">
            <template slot-scope="scope">
              <div v-if="scope.row.recordIncorrect" class="over">不合理</div>
              <el-tag v-else-if="scope.row.incorrect" type="danger" size="mini">有不合理</el-tag>
              <div v-if="scope.row.reviewComment">{{ scope.row.reviewComment }}</div>
              <el-button type="text" size="mini" @click.stop="openRecordReview(scope.row)">
                {{ scope.row.recordIncorrect ? "修改" : "标记不合理" }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column v-if="showLab" label="操作" align="right" width="80">
            <template slot-scope="scope">
              <el-dropdown @command="(command) => handleCommand(command, scope.row)" class="dropdown-meun">
                <span class="el-dropdown-link">
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="1"><span>查询推荐点</span></el-dropdown-item>
                  <el-dropdown-item command="2"><span>下单检测</span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>

        <div class="page">
          <slot name="pager"></slot>
        </div>

        <div class="header">行程检测结果：</div>
        <div v-if="selectItem && idleVehicleLabels(selectItem).length" class="idle-line">
          当时空闲车辆：
          <el-tooltip :disabled="idleVehicleLabels(selectItem).length <= 5" placement="top" effect="dark"
            popper-class="idle-vehicle-tip">
            <div slot="content">
              <span v-for="(label, index) in idleVehicleLabels(selectItem)" :key="index" class="idle-item">
                <span v-if="index">、</span>{{ label }}
              </span>
            </div>
            <span :class="{ 'idle-more': idleVehicleLabels(selectItem).length > 5 }">
              <span v-for="(label, index) in idleVehiclePreview(selectItem)" :key="index" class="idle-item">
                <span v-if="index">、</span>{{ label }}
              </span>
              <span v-if="idleVehicleLabels(selectItem).length > 5"> 等{{ idleVehicleLabels(selectItem).length }}辆</span>
            </span>
          </el-tooltip>
        </div>
        <div class="middle">
          <el-table class="match-table" :data="matchResultList" max-height="300" @row-click="showMap"
            :highlight-current-row="true" size="small">
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column label="司机" width="70">
              <template slot-scope="scope">
                <div>
                  {{ driverNo(scope.row) }}：
                  <el-link type="primary" @click.stop="showDetail(scope.row)">
                    {{
                      scope.row.ok
                        ? scope.row.result && scope.row.result.noNeedCheck
                          ? "不检测"
                          : "顺路"
                        : "不顺路"
                    }}
                  </el-link>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="备注" width="120">
              <template slot-scope="scope">
                <div>{{ scope.row.remark }}</div>
                <div v-if="scope.row.result">
                  <limit-text :width="120" :text="scope.row.result.remark"></limit-text>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="行程时间" width="100">
              <template slot-scope="scope">
                <div>{{ routeShowTime(scope.row) }}</div>
              </template>
            </el-table-column>
            <el-table-column label="剩余座位" width="60">
              <template slot-scope="scope">
                <div>{{ leftSeats(scope.row) }} 人</div>
              </template>
            </el-table-column>
            <el-table-column label="预计上车时间" width="60">
              <template slot-scope="scope">
                <div v-if="scope.row.result">{{ scope.row.result.getupTime | dateFormat("hh:mm") }}</div>
              </template>
            </el-table-column>
            <el-table-column label="接人中" width="70">
              <template slot-scope="scope">
                <div v-if="scope.row.result">{{ scope.row.result.onGoingRoute ? "是" : "否" }}</div>
              </template>
            </el-table-column>
            <el-table-column label="可分流" width="150">
              <template slot-scope="scope">
                <div v-if="scope.row.result">
                  <div>{{ scope.row.result.pickShunt ? "接人分流" : "否" }}</div>
                  <template v-if="shuntSchedule(scope.row)">
                    <div>建议出发 {{ shuntSchedule(scope.row).depart | dateFormat("hh:mm") }}</div>
                    <div>分流到达 {{ shuntSchedule(scope.row).board | dateFormat("hh:mm") }}</div>
                    <div>车辆到达 {{ shuntSchedule(scope.row).vehicle | dateFormat("hh:mm") }}</div>
                  </template>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="顺序" width="60">
              <template slot-scope="scope">
                <div v-if="scope.row.result">{{ scope.row.result.seqOk ? "是" : "否" }}</div>
              </template>
            </el-table-column>
            <el-table-column label="时间" width="60">
              <template slot-scope="scope">
                <div v-if="scope.row.result">{{ scope.row.result.isTimeOk ? "是" : "否" }}</div>
              </template>
            </el-table-column>
            <el-table-column label="接人绕路" width="160">
              <template slot-scope="scope">
                <div v-if="detourOf(scope.row, true)">
                  <div>{{ detourOf(scope.row, true).orderLabel }}</div>
                  <div>
                    时间
                    <span :class="{ over: detourOf(scope.row, true).timeOver }">{{ detourOf(scope.row, true).actualMin
                    }}</span>
                    / {{ detourOf(scope.row, true).allowMin }} 分钟
                  </div>
                  <div>
                    里程
                    <span :class="{ over: detourOf(scope.row, true).distanceOver }">{{ detourOf(scope.row,
                      true).actualKm }}</span>
                    / {{ detourOf(scope.row, true).limitText }}
                  </div>
                </div>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="送人绕路" width="160">
              <template slot-scope="scope">
                <div v-if="detourOf(scope.row, false)">
                  <div>{{ detourOf(scope.row, false).orderLabel }}</div>
                  <div>
                    时间
                    <span :class="{ over: detourOf(scope.row, false).timeOver }">{{ detourOf(scope.row, false).actualMin
                    }}</span>
                    / {{ detourOf(scope.row, false).allowMin }} 分钟
                  </div>
                  <div>
                    里程
                    <span :class="{ over: detourOf(scope.row, false).distanceOver }">{{ detourOf(scope.row,
                      false).actualKm }}</span>
                    / {{ detourOf(scope.row, false).limitText }}
                  </div>
                </div>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="顺路" width="120">
              <template slot-scope="scope">
                <div v-if="scope.row.result">
                  {{ scope.row.result.isDepPointOk && scope.row.result.isDestPointOk }} -
                  {{ scope.row.result.isDepPointOk }}/{{ scope.row.result.isDestPointOk }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="检测时长" width="90">
              <template slot-scope="scope">
                <div>{{ formatCheckCost(scope.row.checkCostMs) }}</div>
              </template>
            </el-table-column>
            <el-table-column label="控制级别" width="90">
              <template slot-scope="scope">
                <el-link @click.stop="showJson(scope.row)">
                  {{ controlArea(scope.row) | enumTransfer(controlAreaOpts) }}
                </el-link>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="110" fixed="right">
              <template slot-scope="scope">
                <div>
                  <el-button v-if="enableDispatch" type="text" size="mini"
                    @click.stop="simulateDispatch(scope.row)">模拟派单</el-button>
                </div>
                <div v-if="scope.row.incorrect" class="over">不合理</div>
                <div v-if="scope.row.reviewComment">{{ scope.row.reviewComment }}</div>
                <el-button type="text" size="mini" @click.stop="openReview(scope.row)">
                  {{ scope.row.incorrect ? "修改标记" : "标记不合理" }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <template v-if="showLab">
          <div class="header">测试结果：</div>
          <div class="middle">
            <el-table :data="testMatchResultList" max-height="200" :highlight-current-row="true" size="small">
              <el-table-column label="序号" type="index" width="50"></el-table-column>
              <el-table-column label="司机" width="100">
                <template slot-scope="scope">
                  <div>
                    {{ driverNo(scope.row) }}：
                    <el-link type="primary" @click.stop="showDetail(scope.row)">
                      {{
                        scope.row.ok
                          ? scope.row.result && scope.row.result.noNeedCheck
                            ? "不检测"
                            : "顺路"
                          : "不顺路"
                      }}
                    </el-link>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="预计上车时间" width="100">
                <template slot-scope="scope">
                  <div v-if="scope.row.result">{{ scope.row.result.getupTime | dateFormat("hh:mm") }}</div>
                </template>
              </el-table-column>
              <el-table-column label="顺序" width="60">
                <template slot-scope="scope">
                  <div v-if="scope.row.result">{{ scope.row.result.seqOk ? "是" : "否" }}</div>
                </template>
              </el-table-column>
              <el-table-column label="时间" width="60">
                <template slot-scope="scope">
                  <div v-if="scope.row.result">{{ scope.row.result.isTimeOk ? "是" : "否" }}</div>
                </template>
              </el-table-column>
              <el-table-column label="可分流" width="150">
                <template slot-scope="scope">
                  <div v-if="scope.row.result">
                    <div>{{ scope.row.result.pickShunt ? "接人分流" : "否" }}</div>
                    <template v-if="shuntSchedule(scope.row)">
                      <div>建议出发 {{ shuntSchedule(scope.row).depart | dateFormat("hh:mm") }}</div>
                      <div>分流到达 {{ shuntSchedule(scope.row).board | dateFormat("hh:mm") }}</div>
                      <div>车辆到达 {{ shuntSchedule(scope.row).vehicle | dateFormat("hh:mm") }}</div>
                    </template>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="顺路" width="120">
                <template slot-scope="scope">
                  <div v-if="scope.row.result">
                    {{ scope.row.result.isDepPointOk && scope.row.result.isDestPointOk }} -
                    {{ scope.row.result.isDepPointOk }}/{{ scope.row.result.isDestPointOk }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="备注">
                <template slot-scope="scope">
                  <div v-if="scope.row.result">
                    <limit-text :width="120" :text="scope.row.result.remark"></limit-text>
                  </div>
                  <div>{{ scope.row.remark }}</div>
                </template>
              </el-table-column>
              <el-table-column label="详情" width="80">
                <template slot-scope="scope">
                  <el-link @click.stop="showJson(scope.row)">详情</el-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </div>
    </div>

    <el-drawer direction="rtl" :visible.sync="resultVisible" custom-class="drawer-modal" append-to-body>
      <div v-if="matchResult && matchResult.result">
        <el-form>
          <el-form-item label="时间：">
            预订：{{ matchResult.result.bookTime }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 上车：
            {{ matchResult.result.getupTime }}
          </el-form-item>
          <el-form-item label="订单编号：">{{ matchResult.result.orderIndexArr }}</el-form-item>
          <el-form-item label="起点阈值：">
            {{ matchResult.result.depThreshold }}
            {{ matchResult.result.depDurationMoreList }} - 直达超时:
            {{ matchResult.result.depExceedList }}
          </el-form-item>
          <el-form-item label="终点阈值：">
            {{ matchResult.result.destThreshold }}
            {{ matchResult.result.destDurationMoreList }} - 直达超时:
            {{ matchResult.result.destExceedList }}
          </el-form-item>
          <el-form-item label="全行程阈值：">{{ matchResult.result.routeThreshold }}</el-form-item>
          <el-form-item label="说明：">{{ matchResult.result.remark }}</el-form-item>
        </el-form>
      </div>
    </el-drawer>

    <el-drawer direction="rtl" title="查看数据" custom-class="drawer-modal" :visible.sync="jsonVisible" append-to-body
      @opened="opened">
      <div ref="jsonBox"></div>
    </el-drawer>

    <el-dialog :title="reviewForm.whole ? '标记整次检测不合理' : '标记不合理'" :visible.sync="reviewVisible" width="420px"
      append-to-body>
      <el-input type="textarea" :rows="4" v-model="reviewForm.reviewComment" placeholder="填写注释，便于后续追溯"></el-input>
      <div slot="footer">
        <el-button v-if="reviewForm.marked" size="small" @click="saveReview(false)">取消标记</el-button>
        <el-button size="small" type="primary" @click="saveReview(true)">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { isTestPointOnTheWay, listUpriceArea, getRecommendPointList, fullOnTheWayCheck, reviewOnwayResult } from "@/api";
import { mapState } from "vuex";
import { MapUtil } from "@/util";
import moment from "moment";
import { ORDER_CHANGE, SHOW_TEST_ROUTE_PLAN } from "@/core/const/global-event";

const markR = require("../../assets/image/mark_r.png");
const markB = require("../../assets/image/mark_b.png");
const markG = require("../../assets/image/mark_g.png");
const markY = require("../../assets/image/mark_y.png");
const markGrey = require("../../assets/image/mark_grey.png");
const markCar = require("../../assets/image/car_blue.png");
const markRecommend = require("../../assets/image/recommend.png");
const markShunt = require("../../assets/image/r2.png");

export default {
  name: "OnwayDetectPanel",
  props: {
    list: { type: Array, default: () => [] },
    showLab: { type: Boolean, default: false },
    enableDispatch: { type: Boolean, default: false },
    height: { type: String, default: "750px" },
    orderId: { type: [Number, String], default: null }
  },
  filters: {
    ticketTime(dateTime) {
      if (!dateTime) {
        return "";
      }
      const time = moment(dateTime);
      const nowStr = time.format("HH:mm");
      const nextHour = time.add(1, "hour");
      return `${nowStr} - ${nextHour.format("HH:mm")}`;
    }
  },
  computed: {
    ...mapState({
      pathOpts: (state) => {
        const pathList = state.pathList || [];
        return pathList.map((item) => ({ label: item.name, value: item.id }));
      }
    })
  },
  watch: {
    showDep() {
      this.showMap();
    },
    list() {
      this.onListChange();
    }
  },
  data() {
    return {
      controlAreaOpts: [
        { label: "不控制", value: 0 },
        { label: "一般", value: 1 },
        { label: "严格", value: 2 }
      ],
      matchResultList: [],
      testMatchResultList: [],
      showDep: true,
      resultVisible: false,
      matchResult: null,
      jsonVisible: false,
      operParam: "",
      selectItem: null,
      reviewVisible: false,
      reviewForm: {
        whole: false,
        onwayResultId: null,
        routeId: null,
        reviewComment: "",
        marked: false
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initMap();
      this.onListChange();
    });
  },
  beforeDestroy() {
    if (this.map) {
      this.map.destroy();
      this.map = null;
    }
  },
  methods: {
    resizeMap() {
      if (this.map) {
        this.map.resize();
      }
    },
    onListChange() {
      if (!this.map) {
        return;
      }
      const list = this.list || [];
      if (!list.length) {
        this.matchResultList = [];
        this._currentItem = null;
        this.selectItem = null;
        this.map.clearMap();
        return;
      }
      this.shouMatchResult(list[0]);
    },
    initMap() {
      if (this.map || !this.$refs.mapEl) {
        return;
      }
      const map = new AMap.Map(this.$refs.mapEl, {
        resizeEnable: true,
        dragEnable: true,
        zoom: 14
      });
      this.map = map;
      AMap.plugin(["AMap.Driving", "AMap.Scale"], () => {
        this.driving = new AMap.Driving({
          policy: AMap.DrivingPolicy.LEAST_TIME,
          map: this.map,
          autoFitView: false,
          hideMarkers: true
        });
        map.addControl(new AMap.Scale());
        if (this.matchResult) {
          this.showMap();
        }
      });
    },
    tableRowClassName({ row }) {
      return this.selectItem && row.id === this.selectItem.id ? "sys" : "";
    },
    driverNo(row) {
      return row.mongoMatchInfo && row.mongoMatchInfo.route ? row.mongoMatchInfo.route.driverNo : "";
    },
    routeShowTime(row) {
      return row.mongoMatchInfo && row.mongoMatchInfo.route ? row.mongoMatchInfo.route.showTime : "";
    },
    leftSeats(row) {
      return row.mongoMatchInfo ? row.mongoMatchInfo.leftSeats : "";
    },
    controlArea(row) {
      return row.mongoMatchInfo && row.mongoMatchInfo.route ? row.mongoMatchInfo.route.controlArea : "";
    },
    idleVehicleLabels(row) {
      const list = (row && row.idleVehicles) || [];
      return list.map((car) => {
        const no = car.driverNo || car.driverId;
        if (!no) {
          return car.source || "-";
        }
        return car.source ? `${no}（${car.source}）` : String(no);
      });
    },
    shuntSchedule(row) {
      const result = row && row.result;
      if (!result || !result.shuntPassengerDepartTime || !result.shuntPassengerArriveTime || !result.shuntVehicleArriveTime) {
        return null;
      }
      const departMs = new Date(result.shuntPassengerDepartTime).getTime();
      const arriveMs = new Date(result.shuntPassengerArriveTime).getTime();
      const vehicleMs = new Date(result.shuntVehicleArriveTime).getTime();
      if ([departMs, arriveMs, vehicleMs].some((time) => Number.isNaN(time))) {
        return null;
      }
      const travel = Math.max(0, arriveMs - departMs);
      let boardMs = vehicleMs - 5 * 60 * 1000;
      let leaveMs = boardMs - travel;
      if (leaveMs < departMs) {
        leaveMs = departMs;
        boardMs = arriveMs;
      }
      return {
        depart: new Date(leaveMs),
        board: new Date(boardMs),
        vehicle: new Date(vehicleMs)
      };
    },
    idleVehiclePreview(row) {
      return this.idleVehicleLabels(row).slice(0, 5);
    },
    formatCheckCost(ms) {
      if (ms == null || ms === "") {
        return "-";
      }
      const cost = Number(ms);
      if (Number.isNaN(cost)) {
        return "-";
      }
      if (cost < 1000) {
        return `${cost}ms`;
      }
      return `${(cost / 1000).toFixed(1)}秒`;
    },
    orderLabel(row, orderId) {
      if (orderId === 0 || orderId === "0") {
        return "0号单";
      }
      const orders = (row.mongoMatchInfo && row.mongoMatchInfo.orders) || [];
      const found = orders.find((item) => item && String(item.id) === String(orderId));
      if (found && found.orderIndex != null && found.orderIndex !== "") {
        return `${Number(found.orderIndex) + 1}号单`;
      }
      return orderId != null ? `${orderId}` : "";
    },
    detourOf(row, isDep) {
      const result = row && row.result;
      if (!result) {
        return null;
      }
      const routeResult = isDep ? result.depRouteResult : result.destRouteResult;
      if (!routeResult || !routeResult.points || !routeResult.points.length) {
        return null;
      }
      const extraList = isDep ? result.depDurationMoreList : result.destDurationMoreList;
      const exceedList = isDep ? result.depExceedList : result.destExceedList;
      const threshold = row.mongoOnwayThreshold || {};
      const moreDuration = routeResult.moreDuration || [];
      const moreDistance = routeResult.moreDistance || [];
      const limitBase = Number(isDep ? threshold.depLimit : threshold.destLimit) || 0;
      const distanceLimit = isDep ? threshold.depDistanceLimit : threshold.destDistanceLimit;
      const unlimited = distanceLimit == null || Number(distanceLimit) <= 0;
      let best = null;
      routeResult.points.forEach((point, index) => {
        if (!point || point.orderId == null || point.orderId === "") {
          return;
        }
        const compared = (extraList && extraList[index] != null) || (exceedList && exceedList[index] != null);
        if (!compared || moreDuration[index] == null) {
          return;
        }
        const extra = extraList && extraList[index] != null ? Number(extraList[index]) || 0 : 0;
        const allowMin = limitBase + extra;
        const actualMin = Math.trunc(Number(moreDuration[index]) / 60);
        const hasExceed = exceedList && exceedList[index] != null && exceedList[index] !== "";
        const exceedMin = hasExceed ? Number(exceedList[index]) : actualMin - allowMin;
        if (Number.isNaN(exceedMin)) {
          return;
        }
        const meters = moreDistance[index] == null ? null : Number(moreDistance[index]);
        const worseTime = !best || exceedMin > best.exceedMin;
        const sameTimeMoreDistance = best && exceedMin === best.exceedMin && (meters || -1) > (best.meters == null ? -1 : best.meters);
        if (worseTime || sameTimeMoreDistance) {
          best = { point, actualMin, allowMin, exceedMin, meters };
        }
      });
      if (!best) {
        return null;
      }
      const distanceOver = !unlimited && best.meters != null && best.meters > Number(distanceLimit);
      return {
        orderLabel: this.orderLabel(row, best.point.orderId),
        actualMin: best.actualMin,
        allowMin: best.allowMin,
        timeOver: best.exceedMin > 0,
        actualKm: best.meters == null ? "-" : (best.meters / 1000).toFixed(1),
        limitText: unlimited ? "不限" : `${(Number(distanceLimit) / 1000).toFixed(1)} 公里`,
        distanceOver: best.meters != null && distanceOver
      };
    },
    renderCityScope(order) {
      if (!order) {
        return;
      }
      const { pathId } = order;
      const isStart = this.showDep;
      const draw = (areaType, style) => {
        listUpriceArea({ pathId, isStart, areaType, _useCache: true }).then((res) => {
          if (!this.map) {
            return;
          }
          const scopes = (res.data || []).map((item) => MapUtil.json2Overlay(item, style));
          if (this.showLab) {
            scopes.forEach((item) => item.on("rightclick", this.clickHandler));
          }
          this.map.add(scopes);
        });
      };
      draw(2, { strokeColor: "#000", fillColor: "transparent", strokeWeight: 2 });
      draw(3, { strokeColor: "#4894ef", fillColor: "transparent", strokeWeight: 2 });
    },
    clearPath() {
      if (this.driving) {
        this.driving.clear();
      }
    },
    shouMatchResult(item) {
      if (!item || !this.map) {
        return;
      }
      this.map.clearMap();
      this.clearPath();
      this._currentItem = item;
      this.selectItem = item;
      this.matchResultList = item.matchResultList || [];
      if (this.matchResultList.length > 0) {
        this.showMap(this.matchResultList[0]);
      } else {
        this.showOrderPoint(item.order);
      }
    },
    showOrderPoint(order) {
      if (!order || !this.map) {
        return;
      }
      this.map.clearMap();
      const { depLatitude, depLongitude, destLatitude, destLongitude, dateTime, number } = order;
      const marker = new AMap.Marker({
        position: this.showDep ? [depLongitude, depLatitude] : [destLongitude, destLatitude],
        icon: new AMap.Icon({ image: markG }),
        anchor: "bottom-center",
        label: {
          direction: "top",
          content: "<div class='info'>" + `${dateTime} ${number}人` + "</div>"
        }
      });
      this.map.add(marker);
      this.map.setFitView();
    },
    showMap(matchResult) {
      if (matchResult) {
        this.matchResult = matchResult;
      }
      if (!this.matchResult || !this.map) {
        return;
      }
      this.testMatchResultList = [];
      this.map.clearMap();
      this.clearPath();
      const showDep = this.showDep;
      const { mongoMatchInfo, mongoOrder, result, routeId } = this.matchResult;
      if (!mongoOrder) {
        return;
      }
      const { depLatitude, depLongitude, destLatitude, destLongitude, dateTime } = mongoOrder;
      if (result == null) {
        const marker = new AMap.Marker({
          position: showDep ? [depLongitude, depLatitude] : [destLongitude, destLatitude],
          icon: new AMap.Icon({ image: markG }),
          anchor: "bottom-center",
          label: {
            direction: "top",
            content: "<div class='info'>" + `0号单 ${dateTime}` + "</div>"
          }
        });
        this.map.add(marker);
        this.map.setFitView();
        return;
      }
      const { depRouteResult, destRouteResult, driverPosition, depKeyPoint, destKeyPoint, isDepPointOk, isDestPointOk, isTimeOk, shuntPoint } = result;
      const routeResult = showDep ? depRouteResult : destRouteResult;
      const points = routeResult && routeResult.points;
      const recommendResult = this._currentItem && this._currentItem.recommendResult;
      this.renderCityScope(mongoOrder);
      const isPointOk = showDep ? isDepPointOk : isDestPointOk;
      const markers = [];
      markers.push(
        new AMap.Marker({
          position: showDep ? [depLongitude, depLatitude] : [destLongitude, destLatitude],
          icon: new AMap.Icon({ image: isPointOk ? (isTimeOk ? markG : markB) : markR }),
          anchor: "bottom-center",
          label: {
            direction: "top",
            content: "<div class='info'>" + `0号单 ${dateTime}` + "</div>"
          }
        })
      );
      if (shuntPoint) {
        markers.push(
          new AMap.Marker({
            position: [shuntPoint.lng, shuntPoint.lat],
            icon: new AMap.Icon({ image: markShunt }),
            anchor: "bottom-center",
            draggable: true,
            label: { direction: "top", content: "<div class='info'>分流点</div>" }
          })
        );
      }
      if (driverPosition && driverPosition.lng && mongoMatchInfo && mongoMatchInfo.route) {
        markers.push(
          new AMap.Marker({
            position: [driverPosition.lng, driverPosition.lat],
            icon: new AMap.Icon({ image: markCar, imageSize: new AMap.Size(40, 40) }),
            anchor: "bottom-center",
            label: {
              direction: "top",
              content: "<div class='info'>" + mongoMatchInfo.route.driverNo + "</div>"
            }
          })
        );
      }
      const orders = (mongoMatchInfo && mongoMatchInfo.orders) || [];
      orders.forEach((item) => {
        const index = item.orderIndex + 1;
        const isGetUp = item.routeStatus > 2 && showDep;
        markers.push(
          new AMap.Marker({
            position: showDep ? [item.depLongitude, item.depLatitude] : [item.destLongitude, item.destLatitude],
            icon: new AMap.Icon({ image: isGetUp ? markGrey : markY }),
            anchor: "bottom-center",
            draggable: true,
            label: {
              direction: "top",
              content: "<div class='info'>" + `${index}号单 ${item.dateTime}` + "</div>"
            }
          })
        );
      });
      if (recommendResult && recommendResult.recommendAddressPoints) {
        recommendResult.recommendAddressPoints.forEach((item) => {
          if (item.routeId === routeId) {
            let label = item.name;
            if (item.arriveTime) {
              label += ` ${item.arriveTime}`;
            }
            markers.push(
              new AMap.Marker({
                position: [item.lng, item.lat],
                icon: new AMap.Icon({ image: markRecommend }),
                anchor: "bottom-center",
                draggable: true,
                label: { direction: "top", content: "<div class='info'>" + `${label}` + "</div>" }
              })
            );
          }
        });
      }
      this.map.add(markers);
      this.map.setFitView();
      this.drawRoute(points, showDep, depKeyPoint, destKeyPoint);
    },
    drawRoute(points, showDep, depKeyPoint, destKeyPoint) {
      if (!this.driving || !points || !points.length || !depKeyPoint || !destKeyPoint) {
        return;
      }
      const mapPoints = points.map((item) => [item.lng, item.lat]);
      const size = mapPoints.length;
      let start;
      let end;
      let waypoints;
      if (!showDep) {
        start = [destKeyPoint.lng, destKeyPoint.lat];
        waypoints = mapPoints.slice(0, size - 1);
        end = mapPoints[size - 1];
      } else {
        start = mapPoints[0];
        waypoints = mapPoints.slice(1, size);
        end = [depKeyPoint.lng, depKeyPoint.lat];
      }
      this.driving.search(start, end, { waypoints, policy: AMap.DrivingPolicy.LEAST_TIME });
    },
    renderTestPath(matchResult, lnglat) {
      this.clearPath();
      const showDep = this.showDep;
      const { result } = matchResult;
      if (!result) {
        return;
      }
      const { depRouteResult, destRouteResult, depKeyPoint, destKeyPoint, shuntPoint, isDepPointOk, isDestPointOk, isTimeOk } = result;
      const routeResult = showDep ? depRouteResult : destRouteResult;
      const points = routeResult && routeResult.points;
      const { lat, lng } = lnglat;
      if (shuntPoint) {
        this.map.add(
          new AMap.Marker({
            position: [shuntPoint.lng, shuntPoint.lat],
            icon: new AMap.Icon({ image: markShunt }),
            anchor: "bottom-center",
            draggable: true,
            label: { direction: "top", content: "<div class='info'>分流点" + (shuntPoint.name || "") + "</div>" }
          })
        );
      }
      const isPointOk = showDep ? isDepPointOk : isDestPointOk;
      const index = this.testMatchResultList.length;
      this.map.add(
        new AMap.Marker({
          position: [lng, lat],
          icon: new AMap.Icon({ image: isPointOk ? (isTimeOk ? markG : markB) : markR }),
          anchor: "bottom-center",
          label: { direction: "top", content: "<div class='info'>" + `测试${index}` + "</div>" }
        })
      );
      this.drawRoute(points, showDep, depKeyPoint, destKeyPoint);
    },
    showDetail(item) {
      this.matchResult = item;
      this.resultVisible = true;
    },
    clickHandler(ev) {
      if (!this.showLab || !this.matchResult || !this._currentItem) {
        return;
      }
      const lnglat = ev.lnglat;
      const { mongoOrder, routeId } = this.matchResult;
      const { lat, lng } = lnglat;
      const param = { ...mongoOrder, routeId, onwayResultId: this._currentItem.id };
      if (this.showDep) {
        param.depLatitude = lat;
        param.depLongitude = lng;
        param.departure = "测试点";
      } else {
        param.destLatitude = lat;
        param.destLongitude = lng;
        param.destination = "测试点";
      }
      isTestPointOnTheWay(param).then((res) => {
        const matchResult = res.data;
        this.testMatchResultList.push(matchResult);
        this.renderTestPath(matchResult, lnglat);
      });
    },
    showJson(json) {
      this.jsonVisible = true;
      this.operParam = JSON.stringify(json);
    },
    opened() {
      try {
        JSON.parse(this.operParam);
        $(this.$refs.jsonBox).JSONView(this.operParam, { collapsed: true });
      } catch (e) {
        this.$message.error("JSON数据不正确");
      }
    },
    handleCommand(command, item) {
      if (command === "1") {
        getRecommendPointList(item.id).then((res) => {
          const data = res.data || {};
          const { recommendAddressPoints = [] } = data;
          if (recommendAddressPoints.length) {
            const markers = recommendAddressPoints.map((point) => {
              let label = point.name;
              if (point.arriveTime) {
                label += ` ${point.arriveTime}`;
              }
              return new AMap.Marker({
                position: [point.lng, point.lat],
                icon: new AMap.Icon({ image: markRecommend }),
                anchor: "bottom-center",
                draggable: true,
                label: { direction: "top", content: "<div class='info'>" + `${label}` + "</div>" }
              });
            });
            this.map.add(markers);
          } else {
            this.$message.error(data.tip);
          }
        });
      } else if (command === "2") {
        fullOnTheWayCheck(item.order).then(() => {
          this.$message.success("下单检测成功");
        });
      }
    },
    currentOrderId() {
      if (this.orderId && Number(this.orderId) !== 0) {
        return this.orderId;
      }
      const item = this._currentItem;
      if (!item) {
        return null;
      }
      if (item.orderId && Number(item.orderId) !== 0) {
        return item.orderId;
      }
      const embeddedId = item.order && item.order.id;
      return embeddedId && Number(embeddedId) !== 0 ? embeddedId : null;
    },
    simulateDispatch(row) {
      const orderId = this.currentOrderId();
      if (!row.routeId || !orderId) {
        this.$message.error("缺少订单或司机行程，无法模拟派单");
        return;
      }
      this.$bus.$emit(SHOW_TEST_ROUTE_PLAN, row.routeId, [orderId], false, (planFinished) => {
        if (planFinished) {
          this.$bus.$emit(ORDER_CHANGE);
        }
      });
    },
    openRecordReview(row) {
      this.reviewForm = {
        whole: true,
        onwayResultId: row.id,
        routeId: null,
        reviewComment: row.reviewComment || "",
        marked: !!row.recordIncorrect
      };
      this.reviewVisible = true;
    },
    openReview(row) {
      if (!this._currentItem) {
        return;
      }
      this.reviewForm = {
        whole: false,
        onwayResultId: this._currentItem.id,
        routeId: row.routeId,
        reviewComment: row.reviewComment || "",
        marked: !!row.incorrect
      };
      this.reviewVisible = true;
    },
    saveReview(incorrect) {
      if (!this.reviewForm.whole && (!this._currentItem || this.reviewForm.routeId == null)) {
        this.$message.error("行程检测记录不存在");
        return;
      }
      reviewOnwayResult({
        onwayResultId: this.reviewForm.onwayResultId,
        routeId: this.reviewForm.whole ? null : this.reviewForm.routeId,
        incorrect,
        reviewComment: incorrect ? this.reviewForm.reviewComment : ""
      }).then((res) => {
        const data = res.data || {};
        const target = (this.list || []).find((item) => item.id === data.id) || this._currentItem;
        if (target) {
          this.$set(target, "incorrect", data.incorrect);
          this.$set(target, "recordIncorrect", data.recordIncorrect);
          this.$set(target, "reviewComment", data.reviewComment);
          this.$set(target, "matchResultList", data.matchResultList || []);
          if (this._currentItem && this._currentItem.id === target.id) {
            this.matchResultList = target.matchResultList;
          }
        }
        this.reviewVisible = false;
        this.$message.success(incorrect ? "已标记" : "已取消标记");
      });
    }
  }
};
</script>

<style scoped lang="less">
/deep/ .drawer-modal {
  width: 800px !important;
  height: 100% !important;
  padding: 0 40px;
}

.onway-panel {
  .main-box {
    display: flex;
    position: relative;

    .right-box {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      top: 10px;
      left: 10px;
    }

    .table {
      width: 980px;
      margin-left: 10px;
      overflow-x: hidden;
      overflow-y: auto;

      .match-table {
        width: 100%;
      }

      .header {
        font-size: 14px;
        margin: 10px 0 10px 5px;
      }

      .idle-line {
        margin: 0 0 8px 5px;
        line-height: 1.6;
        color: #606266;
      }

      .idle-item {
        white-space: nowrap;
      }

      .idle-more {
        cursor: pointer;
        border-bottom: 1px dashed #909399;
      }

      .middle {
        margin-bottom: 20px;
      }
    }

    .map {
      flex: 1;
      min-width: 280px;
    }
  }
}

/deep/ .el-table .sys {
  background: oldlace;
}

.over {
  color: #f56c6c;
}

.idle-vehicle-tip {
  max-width: 480px;
  line-height: 1.6;
}

.idle-vehicle-tip .idle-item {
  white-space: nowrap;
}
</style>
